import * as React from "react"
import {useEffect} from "react"
import {AutocompleteSeeker} from "@ui-seeker/core";
import {generateArrayByNumber} from "@ui-seeker/utils";

import {useRepricingFormData} from "../../@hooks";


const OPTIONS = generateArrayByNumber(24).map(idx => ({
	label: idx > 9 ? `${idx}` : `0${idx}`,
	value: `${idx}`
}))
export default function RepricingFormHoursSelect({ enabled }) {
	const { hours, handleChangeValue } = useRepricingFormData()

	useEffect(() => {
		if (!enabled)
			handleChangeValue('hour', [])
	}, [enabled])

	if (!enabled)
		return <></>

    return <AutocompleteSeeker
		multiple
		options={OPTIONS}
		label="Hours"
		value={hours}
		placeholder="Any hour"
		onChange={e => handleChangeValue('hour', e.target.value)}
	/>
}